import { AutogenModelPnnBuilderProfile, AutogenRowPnnBuilderProfile } from "./autogen/AutogenModelPnnBuilderProfile";

export class ModelPnnBuilderProfile extends AutogenModelPnnBuilderProfile<RowPnnBuilderProfile> {
	constructor() {
		super(RowPnnBuilderProfile);
	}
}

export class RowPnnBuilderProfile extends AutogenRowPnnBuilderProfile {
}